import React from 'react';
import { styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

interface Props {
  data?: any;
  remove?: null | undefined;
  style?: null | undefined;
  chartProp: any;
  fontFamily?: string;
}

const _modifyData = (props: Props) => {
  if (props.remove) {
    return props.data;
  } else {
    return props.data;
  }
};

const tooltipFontSize = 12;
export const ContructTooltipBody = (props: Props) => {
  const _data = _modifyData(props);
  if (!_data) return null;

  return (
    <div className="tooltipContainer">
      <div className="tooltip-data">
        {Object.keys(_data).map((key, index) => (
          <div key={index} className="tooltip-row">
            <div
              className="tooltip-key"
              style={{
                fontSize: tooltipFontSize,
                lineHeight: '1.2',
                maxWidth: 'unset !important',
                fontFamily: props.fontFamily,
              }}
            >
              {key}
            </div>
            <div
              className="tooltip-colon"
              style={{ fontSize: tooltipFontSize, lineHeight: '1.2' }}
            >
              :
            </div>
            <div
              className="tooltip-value"
              style={{
                fontSize: tooltipFontSize,
                lineHeight: '1.2',
                maxWidth: 'unset !important',
                fontFamily: props.fontFamily,
              }}
            >
              {_data[key]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'rgba(1, 1, 1, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
    maxWidth: 'none',
    width: 'auto',
    padding: 0,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    '&::before': {
      backgroundColor: theme.palette.common.white,
      border: '1px solid #F1EFEC',
    },
  },
}));
